import React, { Component } from "react";
import { Row, Col, Alert, InputGroup, InputGroupText } from "reactstrap";

import { FetchData } from "../utils/DataFetch";
import { GetCookie } from "../utils/Common";
import {
  RptProductionTableDefault,
  columns as rptProductionColumns,
} from "./RptProductionTableDefault";
import { RptProductionTableTotals } from "./RptProductionTableTotals";

import { LoadingModal } from "../LoadingModal";
import { exportRowsToExcel } from "../utils/ReportExport";
import { ExcelExportButton } from "./ExcelExportButton";

export class RptProduction extends Component {
  static displayName = RptProduction.name;

  constructor(props) {
    super(props);
    this.state = {
      productionReportList: [],
      jobCount: 0,
      loading: false,
      fetchingData: false,
      alert: {
        color: "info",
        message: "",
        isOpen: false,
      },
      searchModel: {
        StartDate: "",
        EndDate: "",
        InHouseFlg: null,
      },
    };
    this.user = JSON.parse(GetCookie("user"));

    this.renderProductionReportTable =
      this.renderProductionReportTable.bind(this);
    this.renderTotalsTable = this.renderTotalsTable.bind(this);
    //
    this.handleSearchChange = this.handleSearchChange.bind(this);
    //
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.exportProductionReport = this.exportProductionReport.bind(this);
    //
  }

  componentDidMount() {
    document.onmousemove = this.handleOnMouseMove;
    document.onmouseup = this.handleOnMouseUp;
    return () => {
      document.onmousemove = null;
      document.onmouseup = null;
    };
  }

  handleSearchChange(e) {
    let model = { ...this.state.searchModel };
    model[e.target.name] = e.target.value;

    this.setState({ searchModel: model });
  }

  handleKeyDown(e) {
    if (e.key === "Enter") {
      this.populateProductionReportData();
    }
  }

  async populateProductionReportData() {
    this.setState({ fetchingData: true });

    await FetchData(
      "/getrptproduction",
      "POST",
      this.user.token,
      this.state.searchModel
    ).then((data) => {
      this.setState({
        productionReportList: data,
        loading: false,
        fetchingData: false,
      });
    });
  }

  exportProductionReport() {
    exportRowsToExcel({
      rows: this.state.productionReportList,
      columns: rptProductionColumns,
      fileName: "ProductionReport.xlsx",
    });
  }

  renderProductionReportTable(productionReport) {
    return (
      <RptProductionTableDefault
        state={this.state}
        productionReport={this.state.productionReportList}
      ></RptProductionTableDefault>
    );
  }
  renderTotalsTable(productionReport) {
    let lastRowNum = productionReport.length - 1;
    let lastRow = productionReport.slice(lastRowNum);

    return (
      <RptProductionTableTotals
        state={this.state}
        productionReport={lastRow}
      ></RptProductionTableTotals>
    );
  }

  render() {
    let contents = this.state.loading ? (
      <p>
        <em>Loading...</em>
      </p>
    ) : (
      this.renderProductionReportTable(this.state.productionReportList)
    );

    let totalsContents = this.state.productionReportList?.length > 0
      ? this.renderTotalsTable(this.state.productionReportList)
      : null;

    return (
      <div>
        <center>
          <Alert
            color={this.state.alert.color}
            isOpen={this.state.alert.isOpen}
          >
            {this.state.alert.message}
          </Alert>
        </center>
        <h5 id="tabelLabel">Production Report</h5>
        <Row className="align-items-center g-2">
          <Col className="col-3">
            <InputGroup size="sm">
              <InputGroupText>Start Date</InputGroupText>
              <input
                name="StartDate"
                ref={(ref) => (this.txtStartDate = ref)}
                type="date"
                className="form-control form-control-text"
                value={this.state.searchModel.StartDate}
                onChange={this.handleSearchChange}
                onFocus={this.handleSearchFocus}
                onBlur={this.handleSearchBlur}
                placeholder="Start Date"
                onKeyDown={this.handleKeyDown}
              />
              <InputGroupText>End Date</InputGroupText>
              <input
                name="EndDate"
                ref={(input) => {
                  this.EndDate = input;
                }}
                type="date"
                className="form-control form-control-text"
                value={this.state.searchModel.EndDate}
                onChange={this.handleSearchChange}
                onFocus={this.handleSearchFocus}
                onBlur={this.handleSearchBlur}
                placeholder="End Date"
                onKeyDown={this.handleKeyDown}
              />
            </InputGroup>
          </Col>
          <Col className="col-auto">
            <InputGroup size="sm">
              <InputGroupText>Interpreter Type</InputGroupText>
              <select
                name="InHouseFlg"
                className="form-control"
                value={this.state.searchModel.InHouseFlg === null ? '' : String(this.state.searchModel.InHouseFlg)}
                onChange={(e) => {
                  const val = e.target.value === '' ? null : e.target.value === 'true';
                  this.setState((prev) => ({ searchModel: { ...prev.searchModel, InHouseFlg: val } }));
                }}
              >
                <option value="">Both</option>
                <option value="false">Non In-House</option>
                <option value="true">In-House</option>
              </select>
            </InputGroup>
          </Col>
          <Col className="col-auto">
            <InputGroup size="sm">
              <ExcelExportButton
                onClick={this.exportProductionReport}
                title="Export Production Report"
              />
            </InputGroup>
          </Col>
        </Row>
        {/* Show the loading modal if needed */}
        <LoadingModal fetchingData={this.state.fetchingData} />
        <hr />
        <div>{contents}</div>
        <div>{totalsContents}</div>
      </div>
    );
  }
}
